/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {useContext} from "react";
import {TitleAndToggle} from "./pages/widget/TitleAndToggle";
import {PatientsContext} from "./pages/ui/patients/PatientsContext";
import {AppPermissions} from "./utils/Permissions";
import {AppRoleLevel} from "@app/app-shared/permission";

export function DemoToggle() {
    const {demo, setDemo, patients: pMap} = useContext(PatientsContext)
    const _patients = Object.values(pMap);
    if (!_patients.length)
        return null;

    return <AppPermissions appRoles={[AppRoleLevel.Demo]}>
        <div style={{position: "absolute", right: 70, bottom: 40, zIndex: 9000}}>
            <TitleAndToggle
                text={"Demo"}
                on={demo}
                onChange={() => setDemo(!demo)}
                stylable={{className: 'clickable'}}
            />
        </div>
    </AppPermissions>
}
